import { ShoppingBag } from "lucide-react";
import EmptyCart from "./EmptyCart";

export default function OrderSummary({ items }) {
  return (
    <div className="bg-white rounded-lg shadow-sm p-6 sticky top-6">
      <div className="flex items-center mb-4">
        <ShoppingBag className="h-5 w-5 text-gray-500 mr-2" />
        <h2 className="text-lg font-semibold text-gray-900">
          Resumo do Pedido
        </h2>
      </div>

      {items.length === 0 ? (
        <EmptyCart />
      ) : (
        <div className="divide-y divide-gray-200">
          <div className="py-4">
            {items.map((item) => (
              <div key={item.id} className="flex items-start mb-4">
                <div className="flex-shrink-0 h-16 w-16 bg-gray-100 rounded-md overflow-hidden relative">
                  <img
                    src={item.img}
                    alt={item.name}
                    width={64}
                    height={64}
                    className="object-contain"
                  />
                </div>
                <div className="ml-4 flex-1">
                  <h3 className="text-sm font-medium text-gray-900">
                    {item.name}
                  </h3>
                  <p className="text-xs text-gray-500">{item.variant}</p>
                  <div className="flex justify-between mt-1">
                    <p className="text-xs text-gray-500">
                      Qtd: {item.quantity}
                    </p>
                    <p className="text-sm font-medium text-gray-900">
                      {item.price}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Valores e total... */}
          <button className="w-full mt-6 bg-green-600 text-white px-4 py-3 rounded-md hover:bg-green-700">
            Finalizar Compra
          </button>
        </div>
      )}
    </div>
  );
}
